import { useState } from "react";

const issues = {
  "Engine Won't Start": {
    steps: [
      "Check if the battery is dead by turning on the headlights.",
      "Ensure the car is in 'Park' or 'Neutral'.",
      "Check if there's fuel in the tank.",
      "If the issue persists, contact a mechanic."
    ],
    severe: true,
  },
  "Strange Engine Noise": {
    steps: [
      "Check if the oil level is low and refill if necessary.",
      "Listen for any knocking or grinding sounds.",
      "If noise continues, avoid driving and seek a mechanic immediately."
    ],
    severe: true,
  },
  "Car Overheating": {
    steps: [
      "Turn off the AC and let the engine cool down.",
      "Check if the coolant level is low and refill if needed.",
      "If steam is coming from the hood, do not open it until the engine cools completely.",
      "If the problem persists, visit a mechanic."
    ],
    severe: true,
  },
  "Brakes Feel Soft": {
    steps: [
      "Pump the brake pedal a few times to check responsiveness.",
      "Check if the brake fluid level is low.",
      "If the brakes still feel unresponsive, avoid driving and call a mechanic."
    ],
    severe: true,
  },
  "Check Engine Light On": {
    steps: [
      "Ensure the gas cap is tightly sealed.",
      "Check for any unusual smells or sounds.",
      "Use an OBD-II scanner to read error codes if available.",
      "If unsure, have a professional diagnose it."
    ],
    severe: false,
  },
};

export default function QuickDiagnosticTool() {
  const [selectedIssue, setSelectedIssue] = useState("");
  const [diagnosis, setDiagnosis] = useState(null);

  const handleDiagnosis = () => {
    setDiagnosis(issues[selectedIssue]);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-black p-6">
      <h1 className="text-2xl font-bold mb-4">Quick Car Diagnostic Tool</h1>
      <div className="w-full max-w-3xl bg-black p-6 rounded-xl shadow-lg text-white">
        <div>
          <select 
            className="w-full p-2 bg-gray-800 text-white rounded-md" 
            onChange={(e) => setSelectedIssue(e.target.value)}
            value={selectedIssue}
          >
            <option value="">Select an Issue</option>
            {Object.keys(issues).map((issue) => (
              <option key={issue} value={issue}>
                {issue}
              </option>
            ))}
          </select>
          <button 
            onClick={handleDiagnosis} 
            className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white p-2 rounded-md"
          >
            Diagnose
          </button>
          {diagnosis && (
            <div className="mt-6">
              <h2 className="text-lg font-semibold">Troubleshooting Steps:</h2>
              <ul className="list-disc list-inside text-sm mt-2">
                {diagnosis.steps.map((step, index) => (
                  <li key={index}>{step}</li>
                ))}
              </ul>
              {diagnosis.severe && (
                <p className="mt-4 text-red-500 font-bold">This issue may require professional assistance.</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
